module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/cg-862f4608de0f8e9d213cd201d252cecc.svg";